export default {
  default: [
    {
      path: "/dashboard",
      name: "dashboard",
      // redirect: { name: "funders.table" },
      component: () => import("./views/DashboardView.vue")
    }
  ]
};
